import { Injectable } from '@angular/core';
import { UserState } from '../../../statemanagement/user.state';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { CorporateClientState } from '../../../statemanagement/corporate-client.state';

@Injectable({providedIn: 'root'})
export class UsersnapService {
    private static promise;

    constructor(
        private store: Store<{
            user: UserState;
            corporateClient: CorporateClientState;
        }>) {}

    load() {
        if (!UsersnapService.promise) {
            this.loadUsersnap();
        }

        return UsersnapService.promise;
    }

    private loadUsersnap() {
        UsersnapService.promise = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = 'https://widget.usersnap.com/load/f5a2bb5c-889b-48f0-998d-b46c757e37a4?onload=onUsersnapCXLoad';
            script.type = 'text/javascript';
            script.async = true;
            document.getElementsByTagName('head')[0].appendChild(script);
            script.onload = () => {
                (window as any)['onUsersnapCXLoad'] = api => {
                    api.init({
                        locale: localStorage.getItem('language'),
                        button: {isHidden: true}
                    });

                    (window as any).Usersnap = api;
                    resolve(true);
                };
            };
        });
    }

    open() {
        this.load().then(() => {
            (window as any).Usersnap.open();
            (window as any).Usersnap.on('open', event => {
                combineLatest([
                    this.store.pipe(select('user')),
                    this.store.pipe(select('corporateClient'))
                ]).subscribe(([user, client]: [UserState, CorporateClientState]) => {
                    event.api.setValue('visitor', user.email);
                    event.api.setValue('user', { userId: user.userId, email: user.email });
                    event.api.setValue('custom', {
                        corporateClientId: client.corporateClientId,
                        corporateClientName: client.corporateClientName
                    });
                });
            });
        });
    }
}
